import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createActionGroup, createFeature, createReducer, createSelector, on, props } from '@ngrx/store';

// The CMS edu content detail keeps its draft in a ComponentStore, which
// breadcrumbs can't read; this small feature only holds the edu contents
// whose title a breadcrumb needs to select by id.
export const NAME = 'cmsEduContents';

export interface CmsEduContentTitleInterface {
  id: number;
  title?: string;
}

export type State = EntityState<CmsEduContentTitleInterface>;

export const adapter: EntityAdapter<CmsEduContentTitleInterface> = createEntityAdapter<CmsEduContentTitleInterface>();

export const initialState: State = adapter.getInitialState();

export const actions = createActionGroup({
  source: 'CmsEduContents',
  events: {
    'Upsert Cms Edu Contents': props<{ cmsEduContents: CmsEduContentTitleInterface[] }>(),
  },
});

export const feature = createFeature({
  name: NAME,
  reducer: createReducer(
    initialState,
    on(actions.upsertCmsEduContents, (state, { cmsEduContents }): State => adapter.upsertMany(cmsEduContents, state))
  ),
});

/**
 * Null-safe title lookup: returns an empty string while the edu content
 * is not (yet) in the store, so route data (breadcrumbs) can't crash on it.
 *
 * Standalone props-selector: `createFeature`'s `extraSelectors` only accepts
 * single-argument selectors or selector factories.
 */
export const selectName = createSelector(
  feature.selectEntities,
  (entities, byId: { id: number }): string => entities[byId.id]?.title ?? ''
);
